import type { DirectiveBinding } from 'vue';

// extends HTMLElement to add our persolan eventCleaner
interface HTMLElementWithCleanup extends HTMLElement {
  _disableOnClickCleanup?: () => void;
}

export default {
  mounted(el: HTMLElementWithCleanup, binding: DirectiveBinding) {
    const event = binding.arg || 'disable-button'; // default event disable-button
    const clickHandler = () => {
      el.setAttribute('disabled', 'true');
      el.classList.add('forceDisabled'); // Add style
    };

    const handler = () => {
      el.removeAttribute('disabled');
      el.classList.remove('forceDisabled');
    };

    el.addEventListener('click', clickHandler);
    window.addEventListener(event, handler);
    
    // Event cleaner
    el._disableOnClickCleanup = () => {
      el.removeEventListener('click', clickHandler);
      window.removeEventListener(event, handler);
    };
  },

  unmounted(el: HTMLElementWithCleanup) {
    el._disableOnClickCleanup?.();
  }
};
